import React from "react";
import { FormattedMessage } from "react-intl";
export default function ProfileLanguageExit() {
    return (<FormattedMessage id="forms.profile.language.apology" defaultMessage="We apologize for the inconvenience. We are unable to proceed further."/>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfileLanguageInputs/ProfileLanguageExit.tsx